import { EMPTY_SCRIPT_SELECTION } from "./utils";

export function serializeScriptSelectionsScripKey(scriptSelections) {
  return JSON.stringify(
    (scriptSelections || []).map((s) => ({
      exchange: s.exchange ?? "",
      segment: s.segment ?? "",
      symbol: s.symbol ?? "",
      option_type: s.option_type ?? "",
      strike_price: s.strike_price ?? "",
      expiry_date: s.expiry_date ?? "",
    }))
  );
}

export function scriptDropdownValuesFromSelections(scriptSelections) {
  return (scriptSelections || []).map((s) => ({
    exchange: s.exchange,
    segment: s.segment,
    symbol: s.symbol,
    option_type: s.option_type,
    strike_price: s.strike_price,
    expiry_date: s.expiry_date,
  }));
}

export function serializeOrderInputKey(scriptSelections) {
  return JSON.stringify(
    (scriptSelections || []).map((s) => ({
      price: s.price ?? "",
      qtyLots: s.qtyLots ?? "",
      absDisQty: s.absDisQty ?? "",
      transactionType: s.transactionType ?? "",
      productType: s.productType ?? "",
      orderType: s.orderType ?? "",
      validity: s.validity ?? "",
      strategy: s.strategy ?? "",
    }))
  );
}

export function buildOrderInitiationConfigRequestList(sel, exchangeOnly = false) {
  if (!sel?.length) {
    return [{ exchange: "", segment: "", symbol: "", option_type: "", strike_price: "", expiry_date: "" }];
  }
  if (exchangeOnly) {
    return sel.map((s) => ({
      exchange: (s.exchange ?? "").toString().trim(),
      segment: "",
      symbol: "",
      option_type: "",
      strike_price: "",
      expiry_date: "",
    }));
  }
  return sel.map((s) => ({
    exchange: s.exchange || "",
    segment: s.segment || "",
    symbol: s.symbol || "",
    option_type: s.option_type || "",
    strike_price: s.strike_price ?? "",
    expiry_date: s.expiry_date || "",
  }));
}

export function buildDefaultSelection(opts) {
  if (!opts) return null;
  const ex = opts.unique_exchange_options;
  const seg = opts.unique_segment_options;
  const sym = opts.unique_symbol_options;
  const cat = opts.unique_option_type_options;
  const strikes = opts.unique_strike_price_options;
  const exp = opts.unique_expiry_date_options;
  if (!ex?.length || !seg?.length || !sym?.length || !cat?.length || !strikes?.length || !exp?.length) {
    return null;
  }
  const strikeVal = strikes[0];
  const numStrike = strikeVal === "" || strikeVal == null ? 0 : Number(strikeVal);
  return {
    ...EMPTY_SCRIPT_SELECTION,
    exchange: ex[0],
    segment: seg[0],
    symbol: sym[0],
    option_type: cat[0],
    strike_price: Number.isNaN(numStrike) ? 0 : numStrike,
    expiry_date: exp[0],
    transactionType: "Buy",
  };
}

export function mergeSelectionsWithDropdownDefaults(prev, optsList) {
  if (!optsList.length) return prev;
  if (prev.length === 0) {
    const opts = optsList[0];
    const defaultSelection = buildDefaultSelection(opts);
    return defaultSelection ? [defaultSelection] : prev;
  }
  return prev;
}

function effectiveStrikeForQuote(sel, strikes) {
  const raw = sel.strike_price;
  if (raw !== "" && raw != null && !Number.isNaN(Number(raw))) {
    return Number(raw);
  }
  if (strikes?.length) {
    const n = Number(strikes[0]);
    return Number.isNaN(n) ? 0 : n;
  }
  return 0;
}

/**
 * Build get_quote_data rows: use stored selection when set; otherwise use the same value the
 * ScriptComponent Select shows (first list option when state is still ""), so the API payload
 * matches what the user sees in each dropdown.
 */
export function buildQuoteDataRequestListResolved(scriptSelections, scriptDropdowns) {
  const rows = scriptSelections || [];
  const optsList = scriptDropdowns?.quote_drop_down_options_list || [];
  if (!rows.length) return [];

  const pickStr = (val, list) => {
    const t = val != null ? String(val).trim() : "";
    if (t !== "") return t;
    if (list?.length) return String(list[0]).trim();
    return "";
  };

  return rows.map((sel, i) => {
    const o = optsList[i] ?? optsList[0] ?? {};
    const ex = o.unique_exchange_options ?? [];
    const seg = o.unique_segment_options ?? [];
    const sym = o.unique_symbol_options ?? [];
    const cat = o.unique_option_type_options ?? [];
    const strikes = o.unique_strike_price_options ?? [];
    const exp = o.unique_expiry_date_options ?? [];

    return {
      exchange: pickStr(sel.exchange, ex),
      segment: pickStr(sel.segment, seg),
      symbol: pickStr(sel.symbol, sym),
      option_type: pickStr(sel.option_type, cat),
      strike_price: effectiveStrikeForQuote(sel, strikes),
      expiry_date: pickStr(sel.expiry_date, exp),
    };
  });
}
